import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import SelectionDialog from "@icarius-common/selectionDialog";
import useHandleForm from "../courseFormDialog/useHandleForm";

const RelatedSkillsDialog = (props) => {

  const {
    open,
    data,
    skillList,
    userFieldsDefinition,
    submitCallback,
    handleClose,
  } = props;

  const {
    formData,
    submit,
  } = useHandleForm(data, userFieldsDefinition, submitCallback, () => { });

  const handleSubmit = (newSkills) => {
    submit({ ...formData, skills: newSkills });
    handleClose();
  }

  return (
    <SelectionDialog
      open={open}
      items={skillList}
      initialData={formData.skills}
      title={getLocalizedString("relatedSkills")}
      selectedTitle={getLocalizedString("selectedSkills")}
      filterPlaceholder={getLocalizedString("searchSkill")}
      getItemSubtitle={(item) => `${item.type}${item.group ? ` (${item.group})` : ""}`}
      singleSelection={false}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
}

export default RelatedSkillsDialog;